import {
  ControlledDateInput,
  ControlledInput,
} from "components/Card/ControlledInput";
import { ControlledTextArea, MaskedInput } from "components/inputs";
import ControlledSelect from "components/inputs/Select/ControlledSelect";
import { useCallback, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import {
  useGetAmendedReviewByIdQuery,
  usePatchAmendedReviewByIdMutation,
} from "services/ar-screening-api";
import type { AmendedReviewScreeningType } from "types/DataTypes";

const ClientAnalysisSection = () => {
  const { reviewId } = useParams<{ reviewId: string }>();
  const [patchAmendedReviewByIdMutation] = usePatchAmendedReviewByIdMutation();

  const { data: review } = useGetAmendedReviewByIdQuery(
    { reviewId },
    { skip: !reviewId },
  );
  const onSave = useCallback(
    async (field: string, value: unknown) => {
      if (!review?.id) return;

      await patchAmendedReviewByIdMutation({
        id: review.id.toString(),
        data: { [field]: value } as Partial<AmendedReviewScreeningType>,
      });
    },
    [review?.id, patchAmendedReviewByIdMutation],
  );

  const {
    reset,
    control,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    reset({
      explanation: review?.explanation,
      date_received: review?.date_received,
      due_date: review?.due_date,
      date_sent_to_client: review?.date_sent_to_client,
      cms_approval_amount: review?.cms_approval_amount,
      has_greater_than_10_percent_change:
        review?.has_greater_than_10_percent_change,
    });
  }, [review, reset]);

  return (
    <div className="card form audit-and-consulting-card">
      <div className="card__header">Client Analysis</div>
      <div className="card__children">
        <ControlledDateInput
          control={control}
          label="Date Received"
          name="date_received"
          errors={errors}
          onSave={(value) => onSave("date_received", value)}
        />
        <ControlledDateInput
          control={control}
          label="Due Date"
          name="due_date"
          errors={errors}
          onSave={(value) => onSave("due_date", value)}
        />
        <ControlledDateInput
          control={control}
          label="Date Sent To Client"
          name="date_sent_to_client"
          errors={errors}
          onSave={(value) => onSave("date_sent_to_client", value)}
        />
        <ControlledSelect
          control={control}
          name="has_greater_than_10_percent_change"
          errors={errors}
          label="> 10% Change"
          onSave={(o) => onSave("has_greater_than_10_percent_change", o?.value)}
          options={[
            { value: true, label: "Yes" },
            { value: false, label: "No" },
          ]}
        />
        <ControlledInput
          label="CMS Approval Amount"
          control={control}
          name="cms_approval_amount"
          errors={errors}
          onSave={(value) => onSave("cms_approval_amount", value)}
          componentType={MaskedInput}
          mask="dollar"
        />
        <ControlledTextArea
          name="explanation"
          control={control}
          advancedEdit={true}
          label="Explanation"
          onSave={(value) => onSave("explanation", value)}
          errors={errors}
        />
      </div>
    </div>
  );
};

export default ClientAnalysisSection;
